import { Formik } from "formik";
import { Box, Button, InputAdornment } from "@mui/material";
import CustomField from "../shared/CustomTextField";
import { useStore } from "../../hooks/store";
import Styles from "./Form.module.css";
import { sendLoginData } from "../../utils/API/authMethods";
import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";

export default function LoginForm() {
  const store = useStore();
  const nav = useNavigate();
  const [pasShown, setPasShown] = useState(false);
  const handlePasShown = () => {
    setPasShown(!pasShown);
  };
  const initValues = {
    password: "",
    login: "",
  };

  useEffect(() => {}, []);

  const submitLoginData = (values) => {
    const { login, password } = values;
    sendLoginData(login, password).then(({ data, status }) => {
      if (status === 200) {
        const { name, JWT } = data;
        store.login({ name }, JWT);
        const prevPath = localStorage.getItem("prevPath");
        const prevPageState = localStorage.getItem("prevNavState");
        console.log(prevPath);
        if (prevPath !== "/" && prevPath !== null) {
          const pageState =
            prevPageState !== null ? JSON.parse(prevPageState) : null;

          nav(prevPath, { state: pageState });
        } else nav("/bilet");
        return;
      }

      store.setAlert(data, "error");
    });
  };

  return (
    <Formik
      initialValues={initValues}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);

        submitLoginData(values);

        setSubmitting(false);
      }}>
      {({
        values,
        handleChange,
        handleBlur,
        handleSubmit,
        handleReset,

        /* and other goodies */
      }) => (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
          <div className="modal_contatiner" style={{ minHeight: 0 }}>
            <form onSubmit={handleSubmit}>
              <div className={Styles.form_content}>
                <div className={Styles.form_fields}>
                  <CustomField
                    name="login"
                    label="Логин"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.login}
                  />
                  <CustomField
                    type={pasShown ? "text" : "password"}
                    name="password"
                    label="Пароль"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.password}
                    slotProps={{
                      input: {
                        endAdornment: (
                          <InputAdornment
                            position={"end"}
                            onClick={handlePasShown}>
                            {pasShown ? <VisibilityOff /> : <Visibility />}
                          </InputAdornment>
                        ),
                      },
                    }}
                  />
                </div>
              </div>
              <div className="form_actions">
                <Button onClick={handleReset}>Очистить</Button>
                <Button variant="contained" onClick={handleSubmit}>
                  Войти
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}
    </Formik>
  );
}
